import { render, staticRenderFns } from "./DonutChart101.vue?vue&type=template&id=c0ceba1c&scoped=true"
import script from "./DonutChart101.vue?vue&type=script&lang=js"
export * from "./DonutChart101.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ceba1c",
  null
  
)

export default component.exports